import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { Color } from 'ng2-charts';
import { HttpClient } from '@angular/common/http';




/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'page-analytics-chart',
  templateUrl: 'analytics-chart.html',
})
export class AnalyticsChart {
  @Input() type;
  @Input() chartLabels: string[];
  @Input() chartData: any;
  @Input() chartCheck: any;
  @Input() chartColors: any;


  public_key = '';
  sales_total = [];

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient) {
  }

  public chartSalesOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      }],
      yAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      }]
    },
  };


  public chartStackedBarOptions: any = {
    tooltips: {
      displayColors: true,
      callbacks: {
        mode: 'x',
      },
    },
    plugins: {
      tooltip: {
        mode: 'index'
      }
    },
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
        }
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
        type: 'linear',
      }]
    },
    responsive: true,
    maintainAspectRatio: false,
    legend: { position: 'bottom' },
  };

  public chartHorizontalBarOptions: any = {
    indexAxis: 'y',
    legend: {
      display: false,
      position: 'top',
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      }],
      yAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      }]
    },
  };


  public lineChartColors: Color[] = [
    {
      backgroundColor: 'transparent',
      borderColor: 'orange',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];


  public BarOneChartColors: Color[] = [
    {
      backgroundColor: 'orange',
      borderColor: 'orange',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public RadarChartColors: Color[] = [
    {
      backgroundColor: [
        '#F94144',
        '#4D908E',
        '#F8961E',
        '#90BE6D',
        '#43AA8B',
        '#F9844A',
        '#277DA1',
        '#F3722C',
        '#577590',
        '#F9C74F',
        '#F8CFA9',
        '#FFB673',
        '#F8AD6D',
        '#FF7500',
        '#D76B00',
        '#BE5400',
        '#9D4815',
        '#EFD19F',
        '#EFBE7D',
        '#ECA154',
        '#E87722',
        '#CB6015',
        '#A1561C',
        '#603D20',
        '#FFAE62',
        '#FF8F1C',
        '#FF6900',
        '#FE5000',
        '#B94700',
        '#94450B',
        '#653819',
        '#FFB990',
        '#FFA06A',
        '#FF7F32',
        '#FF6A13',
        '#D86018',
        '#A65523',
        '#8B4720',
        '#FAAA8D',
        '#FA9370',
        '#F87C56',
        '#FF8A3D',
        '#F4633A',
        '#EE5340',
        '#EB3300',
        '#FFBE9F',
        '#FF9D6E',
        '#FF7F41',
        '#FF671F',
        '#E35205',
        '#BE531C',
        '#73381D',
        '#DB864E',
        '#E07E3C',
        '#DC6B2F',
        '#DC582A',
        '#C05131',
        '#864A33',
        '#674736',
        '#FFA38B',
        '#FF8D6D',
        '#FF6A39',
        '#FC4C02',
        '#DC4405',
        '#A9431E',
        '#833921',
        '#FFB3AB',
        '#FF8674',
        '#FF5C39',
        '#FA4616',
        '#CF4520',
        '#963821',
        '#6B3529',
        '#F8CFA9',
        '#FFB673',
        '#F8AD6D',
        '#FF7500',
        '#D76B00',
        '#BE5400',
        '#9D4815',
        '#EFD19F',
        '#EFBE7D',
        '#ECA154',
        '#E87722',
        '#CB6015',
        '#A1561C',
        '#603D20',
        '#FFAE62',
        '#FF8F1C',
        '#FF6900',
        '#FE5000',
        '#B94700',
        '#94450B',
        '#653819',
        '#FFB990',
        '#FFA06A',
        '#FF7F32',
        '#FF6A13',
        '#D86018',
        '#A65523',
        '#8B4720',
        '#FAAA8D',
        '#FA9370',
        '#F87C56',
        '#FF8A3D',
        '#F4633A',
        '#EE5340',
        '#EB3300',
        '#FFBE9F',
        '#FF9D6E',
        '#FF7F41',
        '#FF671F',
        '#E35205',
        '#BE531C',
        '#73381D',
        '#DB864E',
        '#E07E3C',
        '#DC6B2F',
        '#DC582A',
        '#C05131',
        '#864A33',
        '#674736',
        '#FFA38B',
        '#FF8D6D',
        '#FF6A39',
        '#FC4C02',
        '#DC4405',
        '#A9431E',
        '#833921',
        '#FFB3AB',
        '#FF8674',
        '#FF5C39',
        '#FA4616',
        '#CF4520',
        '#963821',
        '#6B3529',
        '#F8CFA9',
        '#FFB673',
        '#F8AD6D',
        '#FF7500',
        '#D76B00',
        '#BE5400',
        '#9D4815',
        '#EFD19F',
        '#EFBE7D',
        '#ECA154',
        '#E87722',
        '#CB6015',
        '#A1561C',
        '#603D20',
        '#FFAE62',
        '#FF8F1C',
        '#FF6900',
        '#FE5000',
        '#B94700',
        '#94450B',
        '#653819',
        '#FFB990',
        '#FFA06A',
        '#FF7F32',
        '#FF6A13',
        '#D86018',
        '#A65523',
        '#8B4720',
        '#FAAA8D',
        '#FA9370',
        '#F87C56',
        '#FF8A3D',
        '#F4633A',
        '#EE5340',
        '#EB3300',
        '#FFBE9F',
        '#FF9D6E',
        '#FF7F41',
        '#FF671F',
        '#E35205',
        '#BE531C',
        '#73381D',
        '#DB864E',
        '#E07E3C',
        '#DC6B2F',
        '#DC582A',
        '#C05131',
        '#864A33',
        '#674736',
        '#FFA38B',
        '#FF8D6D',
        '#FF6A39',
        '#FC4C02',
        '#DC4405',
        '#A9431E',
        '#833921',
        '#FFB3AB',
        '#FF8674',
        '#FF5C39',
        '#FA4616',
        '#CF4520',
        '#963821',
        '#6B3529',
        '#F8CFA9',
        '#FFB673',
        '#F8AD6D',
        '#FF7500',
        '#D76B00',
        '#BE5400',
        '#9D4815',
        '#EFD19F',
        '#EFBE7D',
        '#ECA154',
        '#E87722',
        '#CB6015',
        '#A1561C',
        '#603D20',
        '#FFAE62',
        '#FF8F1C',
        '#FF6900',
        '#FE5000',
        '#B94700',
        '#94450B',
        '#653819',
        '#FFB990',
        '#FFA06A',
        '#FF7F32',
        '#FF6A13',
        '#D86018',
        '#A65523',
        '#8B4720',
        '#FAAA8D',
        '#FA9370',
        '#F87C56',
        '#FF8A3D',
        '#F4633A',
        '#EE5340',
        '#EB3300',
        '#FFBE9F',
        '#FF9D6E',
        '#FF7F41',
        '#FF671F',
        '#E35205',
        '#BE531C',
        '#73381D',
        '#DB864E',
        '#E07E3C',
        '#DC6B2F',
        '#DC582A',
        '#C05131',
        '#864A33',
        '#674736',
        '#FFA38B',
        '#FF8D6D',
        '#FF6A39',
        '#FC4C02',
        '#DC4405',
        '#A9431E',
        '#833921',
        '#FFB3AB',
        '#FF8674',
        '#FF5C39',
        '#FA4616',
        '#CF4520',
        '#963821',
        '#6B3529',
        '#F8CFA9',
        '#FFB673',
        '#F8AD6D',
        '#FF7500',
        '#D76B00',
        '#BE5400',
        '#9D4815',
        '#EFD19F',
        '#EFBE7D',
        '#ECA154',
        '#E87722',
        '#CB6015',
        '#A1561C',
        '#603D20',
        '#FFAE62',
        '#FF8F1C',
        '#FF6900',
        '#FE5000',
        '#B94700',
        '#94450B',
        '#653819',
        '#FFB990',
        '#FFA06A',
        '#FF7F32',
        '#FF6A13',
        '#D86018',
        '#A65523',
        '#8B4720',
        '#FAAA8D',
        '#FA9370',
        '#F87C56',
        '#FF8A3D',
        '#F4633A',
        '#EE5340',
        '#EB3300',
        '#FFBE9F',
        '#FF9D6E',
        '#FF7F41',
        '#FF671F',
        '#E35205',
        '#BE531C',
        '#73381D',
        '#DB864E',
        '#E07E3C',
        '#DC6B2F',
        '#DC582A',
        '#C05131',
        '#864A33',
        '#674736',
        '#FFA38B',
        '#FF8D6D',
        '#FF6A39',
        '#FC4C02',
        '#DC4405',
        '#A9431E',
        '#833921',
        '#FFB3AB',
        '#FF8674',
        '#FF5C39',
        '#FA4616',
        '#CF4520',
        '#963821',
        '#6B3529',
      ],
      borderColor: 'transparent',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];


  public doughnutChartOptions: any = {
    maintainAspectRatio: false,
    legend: {
      position: 'right'
    },
    responsive: true,
  };
  public doughnutChartOptionsMobile: any = {
    maintainAspectRatio: false,
    legend: {
      position: 'bottom'
    },
    responsive: true,
  };

  public barChartOptions: any = {
    legend: {
      display: false,
      position: 'bottom',
    },
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  };

}





// WEBPACK FOOTER //
// ./src/pages/analytics/components/analytics-chart/analytics-chart.ts